






















import { Component, mixins, Prop } from 'nuxt-property-decorator'
import { IImageVariants } from '~/assets/interfaces/images'
import MixinGeneral from '~/assets/mixins/general'
import ComponentImage from '~/components/images/image.vue'
@Component({
  components: {
    ComponentImage,
  },
})
export default class ComponentProductFeature extends mixins(MixinGeneral) {
  @Prop({ type: String }) readonly title!: string
  @Prop({ type: [String, Object] }) readonly image!: IImageVariants
  @Prop({ type: String }) readonly value!: string
  @Prop({ type: Boolean }) readonly large!: boolean
}
